import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { CompanyData } from '../../settings/model/company-data.model';
import { EstablishmentService } from './establishment.service';

@Injectable()
export class ChainResolver implements Resolve<Array<CompanyData>> {
  constructor(private establishment: EstablishmentService) {}

  public resolve(): Observable<Array<CompanyData>> {
    return this.establishment.getChain();
  }
}
